import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // Make sure this exports your Firestore instance
import { uploadVisitorImageToStorage } from "./uploadVisitorImageToStorage";

/**
 * Uploads a visitor image to Firebase Storage and saves metadata in Firestore.
 * @param {string} dataURL - The base64 image data (dataURL).
 * @param {string} visitorId - Unique visitor ID or identifier.
 * @param {object} metadata - Any additional metadata (e.g., name, email).
 * @returns {Promise<string>} - The download URL of the uploaded image.
 */
export const saveVisitorImageWithMetadata = async (dataURL, visitorId, metadata = {}) => {
  // 1. Upload image to Storage
  const photoUrl = await uploadVisitorImageToStorage(dataURL, visitorId);
  // 2. Save metadata in Firestore
  const docRef = await addDoc(collection(db, "visitorImages"), {
    visitorId,
    photoUrl,
    ...metadata,
    createdAt: serverTimestamp(),
  });
  return photoUrl;
};
